<template>
  <div class="modal-card animate__animated animate__zoomIn">
    <header class="modal-card-head glass-header">
      <p class="modal-card-title has-text-white has-text-centered w-100">
        {{ evento.id ? 'Editar Evento' : 'Nuevo Evento' }}
      </p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body glass-body">
      <div class="columns is-multiline">
        <div class="column is-12">
          <b-field label="Nombre del Evento" custom-class="has-text-grey-light">
            <b-input 
              v-model="evento.nombre" 
              placeholder="Ej: Food Fest 2026" 
              class="glass-input" 
              required 
            />
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Costo Base" custom-class="has-text-grey-light">
            <b-input 
              type="number" 
              v-model="evento.costo" 
              placeholder="Ej: 190000" 
              class="glass-input" 
            />
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Estado del Evento" custom-class="has-text-grey-light">
            <div class="pt-2">
              <b-switch v-model="evento.activo" type="is-success" class="glass-switch">
                <span :class="evento.activo ? 'has-text-success' : 'has-text-grey-light'">
                  {{ evento.activo ? 'Activo' : 'Inactivo' }}
                </span>
              </b-switch>
            </div>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Color Principal" custom-class="has-text-grey-light">
            <div class="is-flex is-align-items-center">
              <b-input type="color" v-model="evento.color_principal" class="glass-input-color mr-3" />
              <span class="has-text-white is-size-7">{{ evento.color_principal }}</span>
            </div>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Color Secundario" custom-class="has-text-grey-light">
            <div class="is-flex is-align-items-center">
              <b-input type="color" v-model="evento.color_secundario" class="glass-input-color mr-3" />
              <span class="has-text-white is-size-7">{{ evento.color_secundario }}</span>
            </div>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Fecha de Inicio" custom-class="has-text-grey-light">
            <b-input type="date" v-model="evento.fecha_inicio" class="glass-input" />
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Fecha de Fin" custom-class="has-text-grey-light">
            <b-input type="date" v-model="evento.fecha_fin" class="glass-input" />
          </b-field>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot glass-footer is-justify-content-flex-end">
      <b-button @click="$emit('close')" class="is-rounded glass-btn-cancel">Cancelar</b-button>
      <b-button 
        type="is-primary" 
        class="is-rounded glass-btn-save" 
        @click.prevent="registrar"
      >
        {{ evento.id ? 'Actualizar Cambios' : 'Registrar Evento' }}
      </b-button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "FormEvento",
  props: ["eventoProp"],
  data() {
    return {
      evento: {
        nombre: "",
        color_principal: "#3b82f6",
        color_secundario: "#1e293b",
        costo: "",
        fecha_inicio: "",
        fecha_fin: "",
        activo: false,
        id: null,
      },
    };
  },
  mounted() {
    if (this.eventoProp) {
      this.evento = { ...this.eventoProp };
      this.evento.activo = !!this.eventoProp.activo;
    }
  },
  methods: {
    registrar() {
      if (!this.evento.nombre) {
        this.$buefy.toast.open({
          message: 'El nombre es obligatorio',
          type: 'is-danger'
        });
        return;
      }
      this.$emit("registrar", this.evento);
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 100%;
  max-width: 600px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.5);
}

.glass-header {
  background: rgba(30, 41, 59, 0.98) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 20px;
}

.glass-body {
  background: rgba(15, 23, 42, 0.95) !important;
  padding: 30px;
}

.glass-footer {
  background: rgba(30, 41, 59, 0.98) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 20px;
}

.glass-input /deep/ input {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  border-radius: 12px !important;
  transition: all 0.3s ease;
}

.glass-input /deep/ input:focus {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1) !important;
}

.glass-input-color /deep/ input {
  height: 40px;
  width: 60px;
  padding: 5px;
  border-radius: 8px !important;
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}

.glass-btn-save {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  border: none;
  font-weight: 600;
  padding: 0 25px;
}

.glass-btn-cancel {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #94a3b8;
  margin-right: 15px;
}

.glass-btn-cancel:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.w-100 { width: 100%; }
</style>
